import { AnnouncementBanner, theme } from '@ahmdigital/ui';
import { first } from 'lodash/fp';
import { usePathname } from 'next/navigation';

import { GET_TOC_ANNOUNCEMENTS } from '../../models/table-of-contents/queries.gql';
import { INSURANCE_TYPES } from '../../pages/insurance/constants';
import useTableOfContents from '../../cms/utils/use-table-of-contents';

const ALERT_LEVELS = {
  danger: theme.colors.redTint,
  info: theme.colors.blueTint,
  success: theme.colors.greenTint,
  warning: theme.colors.yellowTint,
};

const FINANCIAL_PRODUCT_PATHS = Object.values(INSURANCE_TYPES).map((insuranceType) => `/${insuranceType}-insurance`);

export const getAnnouncementBackgroundColor = (level?: string | null) =>
  ALERT_LEVELS[level as keyof typeof ALERT_LEVELS] ?? theme.colors.blueTint;

const CMSAnnouncementBanner = () => {
  const pathname = usePathname();
  const isFinancialProductsPage = FINANCIAL_PRODUCT_PATHS.some(
    (financialProductPath) => pathname === financialProductPath || pathname.startsWith(`${financialProductPath}/`),
  );

  const { items: alertData } = useTableOfContents({
    query: GET_TOC_ANNOUNCEMENTS,
    skip: isFinancialProductsPage,
    slug: 'sales-banner',
    typename: 'Alert',
  });

  if (isFinancialProductsPage) {
    return null;
  }

  const alertItem = first(alertData)?.item;
  if (!alertItem) {
    return null;
  }

  return (
    <AnnouncementBanner
      message={alertItem.descriptionRaw}
      backgroundColor={getAnnouncementBackgroundColor(alertItem.level)}
    />
  );
};

export default CMSAnnouncementBanner;
